export default __webpack_public_path__ + "static/media/informationImage5.d68db74e.svg";